import { IOnePageShortSections, ONE_PAGE_SHORT_SECTIONS } from 'constants/businessToolSections/onePageShort';

import { OnePageShort } from './OnePageShort/OnePageShort';

export type IOnePageShortFormSections = {
  [key in IOnePageShortSections]: React.ComponentType;
};

export const onePageShortFormSections = {
  [ONE_PAGE_SHORT_SECTIONS.SHORT]: OnePageShort,
};
